import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../../common/api/request';

export interface Cn54bisCn56ResetBlockParams {
  sendingPpo: string;
  receivingPpo: string;
  year: number;
  mailCategory: string;
}

interface UseCn54bisCn56ResetBlockOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

/**
 * Hook for resetting NO3 & CN56 bilateral blocks
 * @param options Configuration options for the mutation
 * @returns Mutation object for resetting blocks
 */
export function useCn54bisCn56ResetBlock(options: UseCn54bisCn56ResetBlockOptions = {}) {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (params: Cn54bisCn56ResetBlockParams) => {
      console.log('Making API request to reset CN54bis CN56 block');
      console.log('Parameters:', JSON.stringify(params, null, 2));
      
      const response = await axios.delete('/cn54bis-cn56-bilateral/by-summary', {
        params: {
          sendingPpo: params.sendingPpo,
          receivingPpo: params.receivingPpo,
          year: params.year,
          mailCategory: params.mailCategory,
        },
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      console.log('Reset block API Response:', response);
      return response.data;
    },
    onSuccess: (data) => {
      // Invalidate related queries to trigger refetch
      queryClient.invalidateQueries({ queryKey: ['cn54bis-cn56-summary'] });
      queryClient.invalidateQueries({ queryKey: ['ipc-td-accounting'] });
      
      // Call the onSuccess callback if provided
      if (options.onSuccess) {
        options.onSuccess(data);
      }
    },
    onError: (error) => {
      // Call the onError callback if provided
      if (options.onError) {
        options.onError(error);
      }
    }
  });
} 